<template>
    <div>
        <cards-tags
            no-bottom-border
            title="Наши программы"
            tagSelectAllName="Все программы"
            tagSelected="Популярное"
            tags
            tagAllEnd
            factoidsDouble
            tags-limit="0"
            :content="itemsContent"
        ></cards-tags>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: "MortgageList",
    props: {
        tabs: {
            type: Array,
        }
    },
    data() {
        return {
            items: [],
            itemsContent: [],
            actualItems: [],
            noCalcPrograms: ['commercial', 'far-east', 'ipoteka-na-pokupku-zhilogo-doma', 'mortgage-medical', 'regions', 'ipoteka-na-mashino-mesto', 'pod-zalog-kvartiry', 'apartments', 'pokupka-iz-pod-zaloga'],
            programsUrl: '/rest/v1/mortgage/programs?where[tab]=Все программы&sort=sort&page[size]=20'
        }
    },
    methods: {
        getAllPrograms() {
            axios.get(this.programsUrl, { headers: {'Accept': 'application/vnd.api+json'} })
                .then((response) => {
                    this.items = response.data.data;
                    this.getitemsContent();
                }
            )
        },
        getitemsContent() {
            this.itemsContent = this.items.map((item) => {
                let obj = {
                    tags: item.attributes.tags ? item.attributes.tags.split(', ') : item.attributes.tags,
                    tagsSign: this.getTagsSign(item.attributes.tags),
                    title: item.attributes.title,
                    subtitle: item.attributes.preview_text,
                    factoids: this.getFactoids(item.attributes, 'factoid'),
                    factoidsSign: this.getFactoids(item.attributes, 'factoidSign'),
                    factoidsHint: this.getFactoids(item.attributes, 'factoidHint'),
                    buttonFirst: 'Подробнее',
                    buttonFirstUrl: item.attributes.link,
                    button: 'Рассчитать условия',
                    buttonUrl: `${item.attributes.link}#mortgage-calc`,
                    imgUrl: item.attributes.big_photo_desktop,
                    imgUrlMob: item.attributes.big_photo_mobile
                }

                if (this.noCalcPrograms.includes(item.attributes.code)) {
                    delete obj.button;
                    delete obj.buttonUrl;
                }

                return obj;
            })
        },
        getFactoids(item, flag) {
            let factoids = [['Диапазон полной стоимости кредита', item.rate_range]];
            let factoidsSigns = [''];
            const factoidsHints = ['Сумма ваших реальных расходов по кредиту в период его действия, включающая платежи по погашению основной суммы долга, уплате процентов, оплате страховой премии и иных расходов, следующих из договора']

            if (item.rate) {
                factoids.push(['Ставка', `${item.rate}%`]);
                if (item.code === 'family-mortgage') factoidsSigns.push('lighting_yellow')
            }

            if (item.period && (item.code === 'perekreditovanie' || item.code === 'mortgage-medical')) {
                factoids.push(['Срок', item.period]);
            }

            if (item.first_installment && item.code !== 'perekreditovanie') {
                factoids.push(['Первоначальный взнос', item.first_installment]);
            }

            return flag === 'factoid' ? factoids : flag === 'factoidSign' ? factoidsSigns : factoidsHints;
        },
        getTagsSign(item) {
            const tags = item ? item.split(', ') : item;
            let tagsSign = [];
            if (tags) {
                tags.forEach(element => {
                    const icon = element === 'Господдержка' ? 'home_gray' : '';
                    tagsSign.push(icon);
                });
            }
            return tagsSign;
        }
    },
    created() {
        this.getAllPrograms();
    }
}
</script>
